import * as React from "react";
import * as ReactDOM from "react-dom";
import styles from "./Modal.module.scss";

// create a portal to an Element to render the cart in
const CartPortal: React.FC<{children?: React.ReactNode}> = (props) => {
  return ReactDOM.createPortal(props.children, document.getElementById("ModalRootElement") as HTMLDivElement);
};

const Modal: React.FC<{
  closeFunction?: (evt: React.MouseEvent<HTMLDivElement>) => void;
  fullScreen?: boolean;
  isVisible: boolean;
}> = (props) => {
  const {children, closeFunction, fullScreen, isVisible} = props;

  React.useEffect(() => {
    const anyModalSection = document.querySelector("#ModalRootElement > section");
    document.body.style.overflow = !!anyModalSection ? "hidden" : "";
  });

  if (!isVisible) {
    return null;
  }

  const onClickProxy = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (closeFunction) {
      closeFunction(event);
    }
  };

  return (
    <CartPortal>
      {!fullScreen && <div className={styles.backdrop} onClick={onClickProxy} />}
      <section
        onClick={(e: React.MouseEvent<HTMLElement>) => e.stopPropagation()}
        className={fullScreen ? styles.popupFullScreen : styles.popupSmall}
      >
        {closeFunction && <div className={styles.closeButton} onClick={onClickProxy} />}
        {children}
      </section>
    </CartPortal>
  );
};

export default Modal;
